export default "__VITE_ASSET__yJbuk8VY__"